import { render, staticRenderFns } from "./RegisterFinish.vue?vue&type=template&id=69dd09bf&scoped=true&"
import script from "./RegisterFinish.vue?vue&type=script&lang=js&"
export * from "./RegisterFinish.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFinish.vue?vue&type=style&index=0&id=69dd09bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dd09bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
